export const STATUS_CODE = {
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
} as const;
